import {Box, Group} from "@mantine/core";
import {IconSum} from "@tabler/icons-react";
import {FormattedQuantity, FormattedQuantityProps} from "../../../../text/FormattedQuantity/FormattedQuantity";

export type DataTableSumFooterProps = FormattedQuantityProps & {}

export const DataTableSumFooter = (props: DataTableSumFooterProps) => {
  const {...rest} = props

  return (
    <Group spacing="xs">
      <Box mb={-4}>
        <IconSum size={16}/>
      </Box>
      <div>
        <FormattedQuantity {...rest} />
      </div>
    </Group>
  )
}
